import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useGetAdmins = () => {
  return trpc.admin.getAdmins.useQuery(undefined, {
    retry: false,
    cacheTime: CACHE_TIME,
    staleTime: STALE_TIME,
    enabled: true,
  });
};
